import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-slate-200 bg-surface-soft overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-12 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-2 mb-6">
                            <img
                                src="/brand/coway-logo.png"
                                srcSet="/brand/coway-logo-small.png 1x, /brand/coway-logo@2x.png 2x"
                                alt="Coway"
                                width="160"
                                height="40"
                                className="h-9 w-auto select-none"
                                draggable={false}
                            />
                        </div>
                        <p className="text-slate-600 text-base max-w-md leading-relaxed">
                            Partagez vos trajets en taxi ou via les principales
                            plateformes VTC avec des personnes allant dans la
                            même direction. Voyagez malin, partagez les frais.
                        </p>

                        <div className="mt-8 space-y-3 text-sm">
                            <a
                                href="mailto:cowayfrance@gmail.com"
                                data-testid="footer-email"
                                className="inline-flex items-center gap-3 text-slate-700 hover:text-coway transition-colors"
                            >
                                <Mail className="w-4 h-4" strokeWidth={1.6} />
                                cowayfrance@gmail.com
                            </a>
                            <div className="flex items-center gap-3 text-slate-600">
                                <MapPin className="w-4 h-4" strokeWidth={1.6} />
                                France
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-4">
                            Produit
                        </h4>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href="/#how"
                                    className="text-slate-600 hover:text-slate-900 transition-colors"
                                >
                                    Fonctionnement
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/#security"
                                    className="text-slate-600 hover:text-slate-900 transition-colors"
                                >
                                    Sécurité
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/#faq"
                                    className="text-slate-600 hover:text-slate-900 transition-colors"
                                >
                                    FAQ
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/#download"
                                    className="text-slate-600 hover:text-slate-900 transition-colors"
                                >
                                    Télécharger
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-4">
                            Légal
                        </h4>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <Link
                                    to="/privacy-policy"
                                    data-testid="footer-link-privacy"
                                    className="text-slate-600 hover:text-slate-900 transition-colors"
                                >
                                    Confidentialité
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/terms"
                                    data-testid="footer-link-terms"
                                    className="text-slate-600 hover:text-slate-900 transition-colors"
                                >
                                    CGU
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/delete-account"
                                    data-testid="footer-link-delete"
                                    className="text-slate-600 hover:text-slate-900 transition-colors"
                                >
                                    Suppression compte
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    data-testid="footer-link-contact"
                                    className="text-slate-600 hover:text-slate-900 transition-colors"
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-4">
                            Téléchargez l'app
                        </h4>
                        <div className="flex flex-col gap-3">
                            <span
                                data-testid="footer-android"
                                className="inline-flex items-center justify-between gap-3 px-4 py-3 rounded-2xl bg-white border border-slate-200 text-sm text-slate-600"
                            >
                                <span>Android</span>
                                <span className="text-coway text-xs font-semibold">
                                    Bientôt disponible
                                </span>
                            </span>
                            <span
                                data-testid="footer-ios"
                                className="inline-flex items-center justify-between gap-3 px-4 py-3 rounded-2xl bg-white border border-slate-200 text-sm text-slate-600"
                            >
                                <span>iPhone</span>
                                <span className="text-coway text-xs font-semibold">
                                    Bientôt disponible
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-slate-200 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <p className="text-xs text-slate-500">
                        © {new Date().getFullYear()} Coway — Édité par Coway, France.
                        Tous droits réservés.
                    </p>
                    <p className="text-xs text-slate-500">
                        Conçu pour les voyageurs malins.
                    </p>
                </div>
            </div>

            <div
                aria-hidden
                className="select-none pointer-events-none absolute -bottom-10 inset-x-0 flex justify-center opacity-[0.05]"
            >
                <img
                    src="/brand/coway-logo.png"
                    alt=""
                    className="w-[95%] max-w-[1400px] h-auto"
                    draggable={false}
                />
            </div>
        </footer>
    );
}
